<template>
  <section class="excess-form">
    <div class="box">
      <h3>Coverage</h3>
      <div
        v-for="(excessItem, excessIndex) in excessForm"
        :key="excessIndex"
      >
        <span>{{ excessItem.label_1 }}</span>
        <div
          v-for="(item, index) in excessItem.details_1"
          :key="index">
          <div class="form-item">
            <span>{{ item.label_2}}</span>
            <div class="flex-sb">
              <template>
                <div
                  v-if="item.field_1"
                  class="form-half">
                  <v-input
                    v-model="item.default_vl_1"
                    :disabled="item.is_disable!=0||disabled"
                    :keyFloatNumber="true"
                    maxlength="9"
                  />
                </div>
                <div
                  v-if="item.field_2"
                  class="form-half">
                  <v-input
                    v-model="item.default_vl_2"
                    :disabled="item.is_disable!=0||disabled"
                    :keyFloatNumber="true"
                    maxlength="9"
                  />
                </div>
              </template>

            </div>
          </div>
        </div>
      </div>
      <div
        v-if="plan_cvr_remark"
        class="form-item">
        <span>Plan Coverage Remark</span>
        <span>{{plan_cvr_remark}}</span>
      </div>
      <div class="flex-sb">
        <div class="form-half">
          <div class="form-item">
            <span>Coverage Remark</span>
            <v-input
              v-model="form.cvr_remark"
              type="textarea"
              :rows="3"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {getReferralPersonalCoverage} from '@/api/refer'
import {getRenewPersonalCoverage} from '@/api/renewal'

export default {
  name: 'HomefireExcessForm',
  mixins: [MixinOptions],
  props: {
    // excess: {
    //   type: Array,
    //   default: () => ([])
    // },
    form: {
      type: Object,
      default: () => ({})
    },
    referId: {
      type: [String, Number],
      default: ''
    },
    formDataLock: {
      type: Number,
      default: 0
    },
    disabled:{
      type:Boolean,
      default:false
    },
    plan_cvr_remark:{
      type: String,
      default: ''
    },
    editType: {
      type: Number,
      default: 1 // 1 - reply, 2 - upgrade, 3 - renew
    },
    renewOrderId:{
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      oldFormDataLock: -1,
      excessForm: [],
    }
  },
  watch: {
    // 表單鎖，外層會更新，數值變化了才可以更新 formData
    formDataLock: {
      handler(val, old = -1) {
        if(val !== old) {
          this.oldFormDataLock = old
        }
      }
    },
    // form: {
    //   immediate: true,
    //   deep: true,
    //   handler(val) {
    //     if(this.formDataLock !== this.oldFormDataLock) {
    //       this.oldFormDataLock = this.formDataLock
    //       Object.keys(this.formData).some(key => {
    //         if(key in val) {
    //           this.formData[key] = val[key]
    //         }
    //       })
    //     }
    //   }
    // }
    'form.plan_id': {
      immediate: true,
      deep: true,
      handler(val) {
        // if(this.formDataLock !== this.oldFormDataLock) {
        //   this.oldFormDataLock = this.formDataLock
        if(val) {
          this.network().getReferralPersonalCoverage()
        }
      }
      // }
    },
    // excess: {
    //   immediate: true,
    //   deep: true,
    //   handler(val) {
    //     if(val && this.formDataLock !== this.oldFormDataLock) {
    //       this.oldFormDataLock = this.formDataLock
    //       this.excessForm = JSON.parse(JSON.stringify(val))
    //     }
    //   }
    // }
  },
  methods: {
    submitForm(formName) {
      // const params = JSON.parse(JSON.stringify(this.excessForm))
      const params = this.handlerExcessFormResult()
      this.$emit('getFormData', formName,params)
      return params
    },
    initExcessForm() {
      // 處理回填 excess
      this.excessForm.some(excess => {
        const name = excess.field_1
        excess.details_1.some(item => {
          // 不知道有多少個，暫時設定為 10  todo
          for(let i = 1; i <= 10; i++) {
            let field = `field_${i}`
            if(!item[field]) {
              continue
            }
            const key = item[field]
            if(name in this.form && this.form[name]) {
              if(key in this.form[name])
                item[`default_vl_${i}`] = this.form[name][key]
            }
          }
        })
      })
    },
    handlerExcessFormResult() {
      let params = {}
      this.excessForm.some(excess => {
        const name = excess.field_1
        params[name] = {}
        excess.details_1.some(item => {
          for(let i = 1; i <= 10; i++) {
            let field = `field_${i}`
            if(!item[field]) {
              continue
            }
            const key = item[field]
            params[name][key] = item[`default_vl_${i}`]
          }
        })
      })
      return params
    },
    network() {
      return {
        getReferralPersonalCoverage: async () => {
          const { company_id, plan_id, id } = this.form
          let params = {
            company_id,
            plan_id,
          }
          if(this.referId) {
            params.refer_id = this.referId
          }
          if(this.editType == 3){
            var {data} = await getRenewPersonalCoverage({
              ...params,
              order_id: this.renewOrderId,
              hideLoading: true
            })
          }else{
            var { data } = await getReferralPersonalCoverage({
              ...params,
              hideLoading: true
            })
          }
          this.excessForm = data
          this.initExcessForm()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .excess-form {
    .flex-excess {
      display: flex;
      align-items: center;
      & > .el-checkbox {
        margin: 0 15px;
      }
      & > span {
        display: inline-block;
        padding: 0 15px;
      }
    }
    .form-excess-half {
      width: 500px;
    }
  }
</style>
